import React from 'react'
import { useIPlatformContext } from '../../../Context/IPlatformContext';
import Link from '../../atoms/Link';
import Text from '../../atoms/Text';
import Container, { CategoryContainerProps } from './index';


const PopularApps = ({ view }: CategoryContainerProps) => {
  const { getMostPopularApp } = useIPlatformContext();
  const Header = () => <div className="flex w-full justify-between items-center"><Text type="H2" className="my-0">Most Popular Apps</Text> <Link  to="/products/iplatform/search"><Text type="H4" className="my-0">SEE ALL</Text></Link></div>
  return (
    <div className="bg-gray-100">
      <Container className="py-8" Header={Header} records={getMostPopularApp?.()} view={view} grid_3={true} />
    </div>
  )
}

export default PopularApps
